import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import NotificationContent from "../../components/Pages/NotificationCenter";
import { useTranslation } from "react-i18next";

const { displayName } = config;

export default function NotificationCenter(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Notifications`;
  }, []);

  return (
    <Layout title={t("routes.notificationCentre")}>
      <NotificationContent />
    </Layout>
  );
}
